import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

import { HttpService } from '../http.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor(private httpService: HttpService,
              private router: Router) { }

  private customerjobPath = 'customerjobs';
  private futurejobsPath = 'futurejobs';
  private openjobsPath = 'openjobs';
  private jobPath = 'job';
  private jobLockPath = 'joblock';

  private jobUrl = '/job/';
  private jobsUrl = '/jobs';

  private jobRescheduleReasonPath = 'reschedule-reasons';
  private jobReschedulePath = 'job-reschedule';
  private jobRequestAssistancePath = 'support-request-types';
  private jobSupportRequestPath = 'support-request';

  private jobTypes = {O : 'On-site', S: 'Parts', R: 'Remote' };
  public jobOnsite = 'O';
  public jobParts = 'S';
  public jobRemote = 'R';




  getJobs(page): Observable<any>{
    return this.httpService.httpGet(this.jobPath + '?page=' + page).pipe(response => {
      return response;
    });
  }

  getFutureJobs(): Observable<any>{
    return this.httpService.httpGet(this.futurejobsPath).pipe(response => {
      return response;
    });
  }

  getOpenJobs(): Observable<any>{
    return this.httpService.httpGet(this.openjobsPath).pipe(response => {
      return response;
    });
  }

  getJobLock(jobID): Observable<any>{
    return this.httpService.httpGet(this.jobLockPath + '/' + jobID).pipe(response => {
      return response;
    });
  }

  getCustomerJobs(customerId, page): Observable<any>{
    return this.httpService.httpGet(this.customerjobPath + '/' + customerId + '?page=' + page).pipe(response => {
      return response;
    });
  }

  getJob(jobID): Observable<any>{
    return this.httpService.httpGet(this.jobPath + '/' + jobID).pipe(response => {
      return response;
    });
  }

  updateJob(body): Observable<any> {
    return this.httpService.httpPut(this.jobPath, body).pipe(response => {
      return response;
    });
  }

  openJob(jobID){
    this.router.navigate([this.jobUrl, jobID]);
  }

  openJobs(id=''){
    this.router.navigate([this.jobsUrl, id]);
  }

  openJobDetails(id) {
    this.router.navigate([this.jobUrl, id, 'details']);
  }

  openInvoice(id) {
    this.router.navigate([this.jobUrl, id, 'invoice']);
  }

  getJobType(jobType) {
    return this.jobTypes[jobType];
  }

  getJobRescheduleReason():Observable<any> {
    return this.httpService.httpGet(this.jobRescheduleReasonPath).pipe(response => {
      return response;
    })
  }

  rescheduleJobs(body): Observable<any> {
    return this.httpService.httpPut(this.jobReschedulePath, body).pipe(response => {
      return response;
    })
  }

  getRequestAssistanceTypes(): Observable<any> {
    return this.httpService.httpGet(this.jobRequestAssistancePath).pipe(response => {
      return response;
    })
  }

  saveRequestAssistance(body): Observable<any> {
    return this.httpService.httpPost(this.jobSupportRequestPath, body).pipe(response => {
      return response;
    })
  }


}
